import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSurveyResults } from '../../../redux/survey/survey_results/actions';
import MainContainer from '../../../components/main_container/MainContainer';
import { tabsOptions } from './tabsOptions';
import CustomTabs from '../../../components/tabs/CustomTabs';
import CustomBreadcrumb from '../../../components/custom_breadcrumb/CustomBreadcrumb';

const SurveyResult = (props) => {

  const { surveyType = 'encuesta', surveyInfo } = useSelector(state => state.surveyResults);

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getSurveyResults({ survey_id: props.match.params.id }));
  }, [props.match.params.id, dispatch]);

  return (
    <MainContainer>
      <CustomBreadcrumb breadcrumbs={[{ name: 'Encuestas', link: '/encuestas' }, { name: `Resultados de ${surveyType.toLowerCase()} ${surveyInfo?.surveyName || ''}`, active: true }]} />
      <h5 className="my-3">Resultados de {surveyType.toLowerCase()}</h5>
      <CustomTabs
        defaultActiveKey="tables"
        id="surveyResultTabs"
        tabs={tabsOptions(surveyType)} />
    </MainContainer>
  )
}

export default SurveyResult